export default {
  path: '/ai_agents/fin_sales_ai',
  name: 'FIN Sales AI',
  redirect: '/ai_agents/fin_sales_ai/select_institution',
  meta: { requiredAuth: true },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'select_institution',
      name: 'SelectInstitution',
      component: () => import('./pages/SelectInstitution'),
      meta: {
        type: 'fin_sales_ai',
        modulePath: '/ai_agents/fin_sales_ai/select_institution'
      }
    },
    {
      path: 'report',
      name: 'SalesReport',
      component: () => import('./pages/Report'),
      meta: {
        type: 'fin_sales_ai',
        modulePath: '/ai_agents/fin_sales_ai/select_institution'
      }
    }
  ]
}
